const InProgressStatusIcon = () => {
  return (
    <svg data-testid="tpInProgressStatus" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="6" r="6" fill="#5097C9" />
    </svg>
  );
};

export default InProgressStatusIcon;
